<template lang="pug">
  layout.view-control-settings
    template(v-slot:toolbar)
      b-navbar()
        //- Tabs
        template(v-slot:start)
          ui-navbar-tabs(:items="navbarTabs")

    template(v-slot:content)
      router-view
</template>

<script>
import { routeTabItem } from '@/utils/nav';

export default {
  name: 'control-settings',

  data: () => ({
    navbarTabs: [
      routeTabItem('control.settings.categories', 'Категории', 'account-card-details'),
      routeTabItem('control.settings.user-groups', 'Группы пользователей', 'account-group'),
    ],
  }),
};
</script>
